export default "__VITE_ASSET__7a9dec42__"